export const cdrTables: Record<string, [number, number, number]> = {
  'prevented-actual-add-instance': [25, 35, 9],
  'prevented-fraud-add-instance': [40, 50, 9],
  'prevented-error-add-instance': [53, 62, 7],
  'details-of-prevention': [65, 68, 5],
  'detected-fraud-add-instance': [84, 94, 10],
  'detected-error-add-instance': [97, 107, 6],
  'recovered-fraud-add-instance': [126, 136, 9],
  'recovered-error-add-instance': [139, 149, 8],
};

export const cdrFields: Record<string, Record<string, string>> = {
  'department-select': {
    department: 'D2',
    sub_organisation: 'D3',
    'report-period': 'D5',
    submitter_name: 'D8',
    submitter_email: 'D9',
    senior_officer_name: 'D12',
    senior_officer_email: 'D13',
    board_member_name: 'D16',
    board_member_email: 'D17',
  },
  'suspected-fraud': {
    fraud_allegations: 'K11',
    fraud_allegations_total: 'M11',
    fraud_allegations_comments: 'O11',
  },
  'suspected-bribery': {
    bribery_allegations: 'K13',
    bribery_allegations_total: 'M13',
    bribery_allegations_comments: 'O13',
  },
  'suspected-whistleblowing': {
    total_allegations: 'K15',
    fraud_allegations_whistleblowing_comments: 'O15',
  },
  'fraud-investigations': {
    fraud_investigations_forward: 'I19',
    fraud_investigations_opened: 'K19',
    fraud_investigations_closed: 'M19',
    fraud_investigations_comments: 'U19',
  },
  'bribery-investigations': {
    bribery_investigations_forward: 'I20',
    bribery_investigations_opened: 'K20',
    bribery_investigations_closed: 'M20',
    bribery_investigations_comments: 'U20',
  },
  'detected-bribery': {
    detected_bribery_c19: 'E112',
    detected_bribery_instances: 'G112',
    detected_bribery: 'I112',
    detected_bribery_comments: 'K112',
  },
  'civil-prosecutions-fraud': {
    prosecutions_civil_fraud_referral: 'M161',
    prosecutions_civil_fraud_proceed_charged: 'O161',
    prosecutions_civil_fraud_successful: 'Q161',
    prosecutions_civil_fraud_comments: 'U161',
  },
  'civil-prosecutions-bribery': {
    prosecutions_civil_bribery_referral: 'M162',
    prosecutions_civil_bribery_proceed_charged: 'O162',
    prosecutions_civil_bribery_successful: 'Q162',
    prosecutions_civil_bribery_comments: 'U162',
  },
  'criminal-prosecutions-fraud': {
    prosecutions_criminal_fraud_referral: 'M166',
    prosecutions_criminal_fraud_proceed_charged: 'O166',
    prosecutions_criminal_fraud_successful: 'Q166',
    prosecutions_criminal_fraud_comments: 'U166',
  },
  'criminal-prosecutions-bribery': {
    prosecutions_criminal_bribery_referral: 'M167',
    prosecutions_criminal_bribery_proceed_charged: 'O167',
    prosecutions_criminal_bribery_successful: 'Q167',
    prosecutions_criminal_bribery_comments: 'U167',
  },
  'civil-sanctions': {
    sanctions_civil_instances: 'M174',
    sanctions_civil: 'O174',
    sanctions_civil_comments: 'Q174',
  },
  'criminal-sanctions': {
    sanctions_criminal_instances: 'M175',
    sanctions_criminal: 'O175',
    sanctions_criminal_comments: 'Q175',
  },
  'civil-cost-awards': {
    costs_awards_civil_instances: 'M179',
    costs_awards_civil: 'O179',
    costs_awards_civil_comments: 'Q179',
  },
  'criminal-cost-awards': {
    costs_awards_criminal_instances: 'M180',
    costs_awards_criminal: 'O180',
    costs_awards_criminal_comments: 'Q180',
  },
  'civil-action': {
    benefits_poca_civil_instances: 'M184',
    benefits_poca_civil: 'O184',
    benefits_poca_civil_comments: 'Q184',
  },
  'criminal-action': {
    benefits_poca_criminal_instances: 'M185',
    benefits_poca_criminal: 'O185',
    benefits_poca_criminal_comments: 'Q185',
  },
  'other-benefits': { other_benefits: 'I190', other_benefits_comments: 'K190' },
  'fraud-against-the-public': {
    fraud_against_public_instances: 'I197',
    fraud_against_public: 'K197',
    fraud_against_public_comments: 'M197',
  },
};

export const cdrAnchors: Record<string, string> = {
  C8: '(1) Organisational Reporting Routes & Investigations',
  E11: 'Fraud allegations received in the given quarter',
  E13: 'Bribery allegations received in the given quarter',
  E15: 'Total Allegations (as reported in ai and aii) that came as a result of whistleblowing',
  G19: 'FRAUD',
  G20: 'BRIBERY',
  E111: 'COVID-19 related?',
  K161: 'FRAUD',
  K162: 'BRIBERY',
  K166: 'FRAUD',
  K167: 'BRIBERY',
  K174: 'CIVIL',
  K175: 'CRIMINAL',
  K179: 'CIVIL',
  K180: 'CRIMINAL',
  K184: 'CIVIL',
  K185: 'CRIMINAL',
  I189: 'Value',
  I196: 'Instances',
};
